<template>
  <generic-modal
    :title="$t('embroidery')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="images" @click="change_active_tab($event, this)">
          <a>
            <i class="image icon" aria-hidden="true"></i>
            <span>{{ $t("images") }}</span>
          </a>
        </li>
        <li data-tab="files" @click="change_active_tab($event, this)">
          <a>
            <i class="fa fa-file mr-2" aria-hidden="true"></i>
            <span>{{ $t("files") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <form>
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
          <div class="field">
            <generic-dropdown
              :title="$t('customer')"
              :placeholder="$t('select customer')"
              :is_multiple="false"
              :add_new="true"
              @add_new="create_customer"
              url="/customer/catalog"
              name_field="name"
              value_field="customer_id"
              @selected="set_customer"
              ref="customer_dropdown"
            />
          </div>
          <div class="field">
            <label class="label">{{ $t("sale price") }}</label>
            <p class="control has-icons-left">
              <input class="input" type="text" v-model="meta.sale_price" />
              <span class="icon is-small is-left">
                {{ get_currency_settings().symbol }}
              </span>
            </p>
          </div>
        </form>
      </div>
      <div class="is-hidden" data-tab="images">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop embroidery images here')"
              endpoint_url="/embroidery/image"
              :extra_data="{ embroidery_uuid: meta.uuid }"
              :allow_multiple="true"
              @error="error_uploading"
              @success="success_uploading"
            />
          </div>
        </div>
        <div class="grid is-col-min-7">
          <div
            v-if="meta && meta.settings && meta.settings.images"
            class="cell"
            v-for="(photo, midx) in meta.settings.images"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7 has-text-centered"></p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="meta.settings.images.splice(midx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="files">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop embroidery files here')"
              endpoint_url="/embroidery/image"
              :extra_data="{ embroidery_uuid: meta.uuid }"
              :allow_multiple="true"
              @error="error_uploading"
              @success="success_uploading_file"
            />
          </div>
        </div>
        <div class="grid is-col-min-7">
          <div
            v-if="meta && meta.settings && meta.settings.files"
            class="cell"
            v-for="(file, midx) in meta.settings.files"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image :src="calculate_icon(file)" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7 has-text-centered">
                      {{ file.original_name }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="meta.settings.files.splice(midx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
  <create-customer-modal ref="create_customer_modal" />
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import CreateCustomerModal from "../../../../customer/frontend/customers_datatable/customer_modal/Index.vue";

export default {
  name: "EmbroideryModal",
  components: {
    GenericModal,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
    CreateCustomerModal,
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();

      v.$refs.generic_modal.show_modal();
    },
    edit_modal(embroidery_uuid) {
      let v = this;
      v.set_initial_state();

      get("/embroidery", { uuid: embroidery_uuid })
        .then((embroidery) => {
          v.meta = embroidery;
          v.$refs.generic_modal.show_modal();
          if (embroidery.customer_id)
            v.$refs.customer_dropdown.set_value(embroidery.customer_id);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/embroidery", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/embroidery", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        customer: "",
        sale_price: "",
        settings: {},
      };
      v.error = "";
      v.$refs.generic_uploader.clear();
      v.$refs.customer_dropdown.clear();
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };
      if (v.meta.settings.images) {
        v.meta.settings.images.push(data);
      } else {
        v.meta.settings.images = [data];
      }
    },
    success_uploading_file(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };
      if (v.meta.settings.files) {
        v.meta.settings.files.push(data);
      } else {
        v.meta.settings.files = [data];
      }
    },
    set_category(categories) {
      let v = this;
      v.meta.categories = categories;
    },
    calculate_icon(file) {
      console.log(file);
      // let v = this;
      if (file.meta.mimetype == "application/pdf")
        // return "https://static.vecteezy.com/system/resources/previews/015/081/201/non_2x/pdf-file-format-3d-rendering-isometric-icon-png.png";
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-pdf-color-red-icon.png";
      else if (file.meta.mimetype == "image/jpeg")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-jpeg-color-red-icon.png";
      else if (file.meta.mimetype == "image/png")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-png-color-red-icon.png";
      else if (file.meta.mimetype == "application/json")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-json-color-red-icon.png";
      else if (file.meta.mimetype == "application/x-javascript")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-js-color-red-icon.png";
      else if (
        file.meta.mimetype ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-xlsx-color-green-icon.png";
      else if (file.meta.mimetype == "text/x-python")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-py-color-green-icon.png";
      else if (file.meta.mimetype == "image/webp")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-webp-color-green-icon.png";
      else
        return "https://cdn.icon-icons.com/icons2/2753/PNG/512/ext_file_generic_filetype_icon_176256.png";
    },
    set_customer(customer) {
      let v = this;
      if (customer) v.meta.customer_id = customer.customer_id;
    },
    create_customer() {
      let v = this;
      v.$refs.create_customer_modal.show_modal();
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
